export let communityList = {
  "跃进村街道": [
    "跃新社区",
    "钢堰社区",
    "堰兴社区",
    "大堰社区",
    "马王街社区",
    "跃进社区",
    "东正社区",
    "渝钢社区",
    "革新社区",
    "钢铁社区"
  ],
  "春晖路街道": [
    "阳光社区",
    "新华社区",
    "松青路社区",
    "古渡社区",
    "锦城社区",
    "柏华社区",
    "锦愉社区",
    "翠华社区",
    "锦凤社区"
  ],
  "茄子溪街道": [
    "园林社区",
    "伏牛溪社区",
    "滨江社区",
    "新港社区",
    "刘家坝社区",
    "永丰社区",
    "陈家坝社区",
    "江州社区",
    "慧丰社区",
    "桥口社区",
    "兴盛社区"
  ],
  "新山村街道": [
    "钢花村社区",
    "平安社区",
    "沪汉社区",
    "光明社区",
    "新一社区",
    "冶建社区",
    "翠园村社区",
    "锁口丘社区"
  ],
  "九宫庙街道": [
    "创新社区",
    "锦霞社区",
    "新工社区",
    "百花社区",
    "葛老溪社区",
  ],
  "跳磴镇": [
    "白沙沱社区",
    "蓝沁苑社区居委会",
    "幸福社区",
    "华庭社区",
    "中顺社区"
  ],
  "八桥镇": [
    "凤阳社区",
    "双林社区",
    "丽景社区",
    "融城社区",
    "龙都社区",
    "双城社区",
    "常嘉社区",
    "万有社区",
    "逸景社区",
    "五一社区"
  ],
  "建胜镇": [
    "新雨社区",
    "建新社区",
    "回龙桥社区",
    "百佳园社区",
    "建路社区",
    "白居寺社区"
  ]
}
export let coordinateList = {
  "跃新社区": [106.49, 29.49],
  "钢堰社区": [
    106.488534, 29.490107
  ],
  "堰兴社区": [106.50, 29.49],
  "大堰社区": [106.488534, 29.490107],
  "马王街社区": [106.499814, 29.494916],
  "跃进社区": [106.499137, 29.492806],
  "东正社区": [106.491783, 29.496538],
  "渝钢社区": [106.504572, 29.494409],
  "革新社区": [106.499805, 29.494912],
  "钢铁社区": [106.504572, 29.494409],
  "阳光社区": [106.487498, 29.480944],
  "新华社区": [106.487525, 29.480962],
  '松青路社区': [106.486305, 29.482454],
  '古渡社区': [106.487284, 29.462711],
  '锦城社区': [106.483537, 29.477055],
  '柏华社区': [106.478203, 29.461174],
  '锦愉社区': [106.479953, 29.486767],
  '翠华社区': [106.480404, 29.483564],
  '锦凤社区': [106.489021, 29.492292],
  '园林社区': [106.520825, 29.417075],
  '伏牛溪社区': [106.485052, 29.421346],
  '滨江社区': [106.51031, 29.428454],
  '新港社区': [106.504383, 29.436414],
  '刘家坝社区': [106.496315, 29.433253],
  '永丰社区': [106.502109, 29.434431],
  '陈家坝社区': [108.418625, 30.799973],
  '江州社区': [106.497037, 29.455054],
  '慧丰社区': [106.497227, 29.437809],
  '桥口社区': [106.494277, 29.447618],
  '兴盛社区': [106.490013, 29.442517],
  '钢花村社区': [106.495951, 29.491402],
  '平安社区': [106.488534, 29.490107],
  '沪汉社区': [106.494758, 29.491991],
  '光明社区': [116.66847, 40.136585],
  '新一社区': [106.489604, 29.491989],
  '冶建社区': [106.494104, 29.485703],
  '翠园村社区': [106.488699, 29.484053],
  '锁口丘社区': [106.492025, 29.487953],
  '创新社区': [106.488534, 29.490107],
  '锦霞社区': [106.489021, 29.492292],
  '新工社区': [106.488534, 29.490107],
  '百花社区': [106.496194, 29.468752],
  '葛老溪社区': [106.501227, 29.46379],
  '白沙沱社区': [106.439001, 29.409026],
  '蓝沁苑社区居委会': [106.43594, 29.405293],
  '幸福社区': [106.457599, 29.456355],
  '华庭社区': [106.439001, 29.409026],
  '中顺社区': [106.448882, 29.41307],
  '凤阳社区': [106.473564, 29.43305],
  '双林社区': [106.474753, 29.500744],
  '丽景社区': [106.488534, 29.490107],
  '龙都社区': [106.471045, 29.499406],
  '常嘉社区': [106.474487, 29.437986],
  '万有社区': [116.590259, 39.923596],
  '逸景社区': [106.476811, 29.43957],
  '五一社区': [106.48911, 29.481431],
  '新雨社区': [106.503646, 29.43404],
  '建新社区': [106.503646, 29.43404],
  '回龙桥社区': [106.501054, 29.431517],
  '百佳园社区': [106.484063, 29.437315],
  '建路社区': [106.520212, 29.415635],
  '白居寺社区': [106.504738, 29.419163]
}
